import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";

export default function DataTable({ title, columns, rows, empty = "No records found", actions }) {
  return (
    <Card className="border border-gray-200">
      {(title || actions) && (
        <CardHeader className="border-b border-gray-200 bg-gray-50/50 py-4">
          <div className="flex items-center justify-between gap-3">
            {title && <CardTitle className="font-manrope text-base">{title}</CardTitle>}
            {actions}
          </div>
        </CardHeader>
      )}
      <CardContent className="p-0">
        {rows.length === 0 ? (
          <div className="p-8 text-center text-hospital-text-muted">{empty}</div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full data-table">
              <thead>
                <tr className="border-b border-gray-200">
                  {columns.map((column) => (
                    <th key={column.key} className={`px-5 py-3 ${column.align === "right" ? "text-right" : "text-left"}`}>
                      {column.label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rows.map((row, index) => (
                  <tr key={row.id || index} className="border-b border-gray-100 last:border-0">
                    {columns.map((column) => (
                      <td key={column.key} className={`px-5 py-4 ${column.align === "right" ? "text-right" : "text-left"}`}>
                        {column.render ? column.render(row) : row[column.key]}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
